export enum EnrollTypesEnum {
    All = 'A',
    Individual = 'I',
    Corporate = 'C'
}
